export enum PaymentFlowType {
  PayOnly,
  PayAndSave,
  SaveOnly,
  CancelFees
}

export enum AmountToCollectMode {
  STRICT = 'STRICT',
  FLEXIBLE = 'FLEXIBLE'
}

export enum PatientPaymentMode {
  NO_PAYMENT = 'NO_PAYMENT',
  COLLECT_PAYMENT = 'COLLECT_PAYMENT',
  COLLECT_AND_SAVE_CARD = 'COLLECT_AND_SAVE_CARD',
  SAVE_CARD = 'SAVE_CARD'
}

export enum ApplicableFor {
  DME = 1,
  Patient,
  Both
}

export enum PaymentStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Declined = 'Declined',
  Failed = 'Failed'
}
